import './styles.scss';
import React, {Dispatch, useContext, useState} from "react";

/* Types, Constants, Utils */
import * as Constants from "../../../../constants";

/* Bootstrap */
import {Dropdown, OverlayTrigger, Tooltip} from "react-bootstrap";

/* Components */
import ReportIssueModal from "../../../modal/report-issue-modal";
import ShareModal from "../../../modal/share-modal";
import TagsNotesModal from "../../../tags-notes/tags-note-modal";
import CiteModal from "../../../modal/cite-modal";
import {IResultsState, ISelected} from "../../../../types/redux/result";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../redux";
import {CardContext, IContext} from "../../../../types/document";
import {AnyAction} from "@reduxjs/toolkit";
import {clearSelectedResults} from "../../../../redux/slices/result-slice";
import {IUserState} from "../../../../types/redux/user";

interface IProps {
  context: string
}

const PageToolsKebab = (props: IProps) :JSX.Element => {
  const {
    context
  } = props;

  /* redux */
  const selectedResults: ISelected[] = useSelector<RootState, IResultsState>(state => state.result).selected_ids;
  const userState: IUserState = useSelector<RootState, IUserState>(state => state.user);

  /* context */
  const cardContext: any = useContext<IContext>(CardContext).context;

  /*
    console.log("cardContext " + cardContext) //document, bibliography, search, history
    console.log('context ' + context) //toolbar, card
  */

  /* state */
  const [reportIssueModalShow, setReportIssueModalShow] = useState<boolean>(false);
  const [shareModalShow, setShareModalShow] = useState<boolean>(false);
  const [tagsNotesModalShow, setTagsNotesModalShow] = useState<boolean>(false);
  const [citeModalShow, setCiteModalShow] = useState<boolean>(false);

  /* hooks */
  const dispatch:Dispatch<AnyAction> = useDispatch();

  return (
    <div className={'page-tools-kebab ms-1'}>
      <Dropdown className={'dropdown'}>
        <OverlayTrigger overlay={
          <Tooltip className={(context !== Constants.TOOLBAR) || selectedResults.length ? 'hidden' : ''}>{Constants.TOOLTIP_PAGE_PAGE_TOOLS}</Tooltip>
        }>
          <span> {/* enable bs tooltip to display when button is disabled */}
            <Dropdown.Toggle
              disabled={(context === Constants.TOOLBAR) && (selectedResults.length === 0)}
              className={"btn btn-sm btn-light mt-1"}
              aria-label="More"
            >
              <i className={'bi bi-three-dots'}/>
            </Dropdown.Toggle>
          </span>
        </OverlayTrigger>

        <Dropdown.Menu className={'text-small'}>
          {(cardContext === Constants.DOCUMENT) &&
            <>
              {/* Toolbar ONLY - Add Tag / Note */}
              {(context === Constants.TOOLBAR) &&
                <Dropdown.Item
                  className={''}
                  onClick={() => setTagsNotesModalShow(true)}
                >
                  <i className={'bi bi-tag h5'}/>
                  <span className={'ms-1 me-1 align-middle'}>Add Tag/Note</span>
                </Dropdown.Item>}

              {/* Cite */}
              {(context !== Constants.TOOLBAR) && <Dropdown.Item
                  className={'py-2'}
                  onClick={() => setCiteModalShow(true)}
                >
                  <i className={'bi bi-quote'}/>
                  <span className={'ms-2 me-1'}>Cite</span>
                </Dropdown.Item>}

              {/* Share */}
              <Dropdown.Item
                className={'py-2'}
                onClick={() => setShareModalShow(true)}
              >
                <i className={'bi bi-share'}/>
                <span className={'ms-2 me-1'}>Share</span>
              </Dropdown.Item>
            </>}

          {/* Share */}
          {(cardContext === Constants.BIBLIOGRAPHY) &&
            <Dropdown.Item
            className={'py-2'}
            onClick={() => setShareModalShow(true)}
          >
            <i className={'bi bi-share'}/>
            <span className={'ms-2 me-1'}>Share</span>
          </Dropdown.Item>}

          {/* Divider */}
          <Dropdown.Divider />

          {/* Report an Issue */}
          <Dropdown.Item
            onClick={()=>setReportIssueModalShow(true)}
          >
            <span>Report Issue</span>
          </Dropdown.Item>

        </Dropdown.Menu>
      </Dropdown>

      {<ReportIssueModal
        context={Constants.TOOLBAR}
        defaultSelection={Constants.ACCESSIBILITY_ISSUES}
        show={reportIssueModalShow}
        onHide={() => {
          setReportIssueModalShow(false);
          dispatch(clearSelectedResults())
        }}
      />}

      {<ShareModal
        show={shareModalShow}
        onHide={() => {
          setShareModalShow(false);
          dispatch(clearSelectedResults())
        }}
      />}

      {tagsNotesModalShow &&
        <TagsNotesModal
          onHide={() => {
            setTagsNotesModalShow(false);
            if (userState.loggedIn) {
              dispatch(clearSelectedResults())
            }
          }}
      />}

      {<CiteModal
        show={citeModalShow}
        onHide={() => {
          setCiteModalShow(false);
          dispatch(clearSelectedResults())
        }}
      />}

    </div>
  )
}
export default PageToolsKebab;
